// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2FCMG","clinicsSelect":"TableHeading_clinicsSelect__3pAmx"};